import React from "react";
import "./bottom-image.css";

export const BottomImage = () => {
  const imgBox: string = require("../../../assets/Groupe_1364.svg").default;
  return (
    <div  className="position-absolute bottom-0 end-0 imageBox">
        <img src={imgBox} alt=" Spb" className='ImageBoxBottom' />
    </div>
  );
};

export default BottomImage;
